import React from 'react';
import PerformanceMark from '@atlassian/jira-common-performance/src/set-performance-mark.tsx';
import ErrorBoundary from '@atlassian/jira-error-boundary/src/ErrorBoundary.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazy } from '@atlassian/react-loosely-lazy';
import { LOAD_START_MARK_KEY } from './saveAndReauthorizeMailServerSubmitBtn.constants.tsx';
import type ConfigureMailServer from './ConfigureMailServerModal.tsx';
import type { ModalProps } from './ModalPropsWithDefault.types.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const AsyncLazyConfigureMailServerModal = lazy<typeof ConfigureMailServer>(
	() =>
		import(
			/* webpackChunkName: "async-configure-mail-server-modal" */ './ConfigureMailServerModal.tsx'
		),
);

const AsyncConfigureMailServerModal = (props: ModalProps): React.JSX.Element => (
	<ErrorBoundary id="configure-mail-server-modal" packageName="jira-configure-mail-server-modal">
		<Placeholder
			name="configure-mail-service-modal"
			fallback={<PerformanceMark metricKey={LOAD_START_MARK_KEY} />}
		>
			<AsyncLazyConfigureMailServerModal {...props} />
		</Placeholder>
	</ErrorBoundary>
);

export default AsyncConfigureMailServerModal;
